import { Dispatch, SetStateAction, memo } from 'react';
import FiltersSearchbox from './filtersSearchbox/FiltersSearchbox';
import FiltersMenu from './filtersMenu/FiltersMenu';
import Box from '@/components/UI/box/Box';
import useDevice from '@/hooks/useDevice';
import styles from './Filters.module.scss';
export interface filtersProps {
  isShowMap: boolean;
  setIsShowMap: Dispatch<SetStateAction<boolean>>;
  setMapFullscreen: Dispatch<SetStateAction<boolean>>;
}
const Filters = (props: filtersProps) => {
  const {
    isMobile
  } = useDevice();
  return <>
      {!isMobile && <Box style={{
      height: '78px'
    }} />}
      <Box className={styles['filters-container'] + ' ' + `${props.isShowMap || isMobile ? styles['show-map'] : ''}`} data-sentry-element="Box" data-sentry-source-file="Filters.tsx">
        {isMobile && <FiltersSearchbox />}
        <FiltersMenu {...props} data-sentry-element="FiltersMenu" data-sentry-source-file="Filters.tsx" />
      </Box>
    </>;
};
export default memo(Filters);